import styled, { css } from "styled-components";

import { info as navBarInfo } from "@components/Navigation/NavBar";
import { Link } from "@components/Navigation/Link";

import { Arrow as ArrowIcon } from "@ui/Assets/MyIcons";
import { Text } from "@ui/Atoms/Text";

export const Header = styled.header`
  --custom-drawer-header-height: ${navBarInfo.headerHeight.default};

  height: calc(var(--custom-drawer-header-height) * 1px);
  padding: ${({ theme }) =>
    `${theme.spacing.spacing_8} var(--drawer-padding) ${theme.spacing.spacing_12}`};
  flex: 0 0 calc(var(--custom-drawer-header-height) * 1px);
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: flex-end;
  gap: ${props => props.theme.spacing.spacing_16};

  ${props => props.theme.breakpointsV2.smallTablet} {
    --custom-drawer-header-height: ${navBarInfo.headerHeight.smallTablet};
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    --custom-drawer-header-height: ${navBarInfo.headerHeight.smallDesktop};
  }
`;

interface ButtonProps {
  $position?: string;
}

export const Button = styled(Link).attrs({
  as: "button",
  type: "button",
  $style: "medium_18",
})<ButtonProps>`
  ${props =>
    !!props.$position &&
    css`
      grid-column: ${props.$position};
    `}
`;

export const Arrow = styled(ArrowIcon)`
  transform: rotate(180deg);
`;

export const HeaderText = styled(Text)`
  text-align: center;
`;
